<template>
  <transition name="back-top">
    <button v-if="shown && !editing" class="back-to-top" :class="{ 'with-tabs': withTabs }" :style="dockBottom === null ? null : { bottom: dockBottom + 'px' }" type="button" aria-label="回到顶部" @click="toTop">
      <app-icon name="to-top" />
      <span>顶部</span>
    </button>
  </transition>
</template>
<script>
export default {
  props: { withTabs: Boolean },
  data() { return { shown: false, editing: false, dockBottom: null } },
  watch: {
    '$route.fullPath'() {
      this.shown = false
      this.$nextTick(this.queueUpdate)
    }
  },
  mounted() {
    this.scrollFrame = null
    window.addEventListener('scroll', this.queueUpdate, { passive: true })
    window.addEventListener('resize', this.queueUpdate, { passive: true })
    document.addEventListener('focusin', this.queueUpdate)
    document.addEventListener('focusout', this.queueUpdate)
    this.queueUpdate()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.queueUpdate)
    window.removeEventListener('resize', this.queueUpdate)
    document.removeEventListener('focusin', this.queueUpdate)
    document.removeEventListener('focusout', this.queueUpdate)
    if (this.scrollFrame !== null) window.cancelAnimationFrame(this.scrollFrame)
  },
  methods: {
    queueUpdate() {
      if (this.scrollFrame !== null) return
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null
        this.update()
      })
    },
    update() {
      const top = window.pageYOffset || document.documentElement.scrollTop || 0
      const range = Math.max(0, document.documentElement.scrollHeight - window.innerHeight)
      this.shown = top > Math.min(320, Math.max(96, range / 2))
      const active = document.activeElement
      this.editing = !!active && (/^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName) || active.isContentEditable)
      const dock = document.querySelector('.page .dock')
      const height = dock ? dock.getBoundingClientRect().height : 0
      this.dockBottom = height > 0 ? Math.ceil(height) + 12 : null
    },
    toTop() {
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      try { window.scrollTo({ top: 0, left: 0, behavior: reduced ? 'auto' : 'smooth' }) }
      catch (e) { window.scrollTo(0, 0) }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/back-to-top.vue